import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import React, { FunctionComponent } from "react";

export const CurrencyIcon: FunctionComponent<SvgIconProps> = (props) => (
	<SvgIcon
		viewBox="0 0 24 24"
		{...props}
	>
		<g clipPath="url(#clip0_979_368)">
			<path d="M11.8001 10.9C9.53006 10.31 8.80006 9.705 8.80006 8.755C8.80006 7.665 9.80506 6.9 11.5001 6.9C13.2801 6.9 13.9401 7.75 14.0001 9H16.2101C16.1451 7.275 15.0901 5.705 13.0001 5.19V3H10.0001V5.16C8.06006 5.585 6.50006 6.835 6.50006 8.77C6.50006 11.08 8.41506 12.23 11.2001 12.9C13.7051 13.5 14.2001 14.375 14.2001 15.315C14.2001 16 13.7151 17.1 11.5001 17.1C9.44006 17.1 8.62506 16.175 8.52006 15H6.31506C6.44006 17.19 8.07506 18.415 10.0001 18.83V21H13.0001V18.85C14.9451 18.475 16.5001 17.35 16.5001 15.295C16.5001 12.465 14.0701 11.495 11.8001 10.9Z" fill="#79818F" />
		</g>
		<defs>
			<clipPath id="clip0_979_368">
				<rect
					fill="white"
					height="24"
					width="24"
				/>
			</clipPath>
		</defs>
	</SvgIcon>
);

export default CurrencyIcon;
